import { css } from '@emotion/react';
import { graphql } from 'gatsby';
import React from 'react';
import StyledAccordion from '../../../atoms/styled-accordion';
import Container from '../../../atoms/Container';
import paddingDefault from '../../../utils/paddingDefault';
import apCaseOnlyTitleTags from '../../../utils/apCaseOnlyTitleTags';
import { StyledButtonAsLink } from '../../../primitives/styled-button';
import { breakpoints } from '../../../primitives/tokens';
import { FaqsData } from '../types/faqsTypes';

interface FaqsGridProps {
    faqs: FaqsData;
}

const styles = {
    faqHeading: css({
        marginBottom: '24px',
        fontSize: '32px',
        lineHeight: 1.25,
        textAlign: 'center',
        [breakpoints.mb]: {
            marginBottom: '16px',
        },
    }),
    flexContainer: css({
        display: 'flex',
        flexDirection: 'row',
        [breakpoints.mb]: {
            display: 'block',
        },
    }),
    fullWidth: css({
        width: '100%',
    }),
    linkWrapper: css({
        display: 'flex',
        marginTop: '48px',
        [breakpoints.mb]: {
            marginTop: '40px',
        },
    }),
};

const FaqsGrid = ({ faqs }: FaqsGridProps): JSX.Element => {
    const { link, heading, byline, questions, settings } = faqs;
    const transformedData = {
        heading,
        byline,
        questions,
        settings,
        link,
    };

    return (
        <Container>
            <div css={[paddingDefault(), styles.flexContainer]}>
                <div css={styles.fullWidth}>
                    <h2 css={styles.faqHeading}>
                        {heading && apCaseOnlyTitleTags(heading)}
                    </h2>
                    <StyledAccordion
                        columns={1}
                        faqs={transformedData}
                        onMediaContent
                    />
                    {link?.href && (
                        <div css={styles.linkWrapper}>
                            <StyledButtonAsLink to={link.href}>{link.title}</StyledButtonAsLink>
                        </div>
                    )}
                </div>
            </div>
        </Container>
    );
};

export const query = graphql`
  fragment FaqsGridData on CmsPageBuilderBlocks {
    faqs_grid {
      faqs {
        heading
        questions {
          questions {
            question
            answer
          }
        }
        link {
          href
          title
        }
      }
    }
  }
`;

export default FaqsGrid;
